import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import JsonLD from "@/components/base/JsonLD";
import { personSchema } from "@/components/base/PageSchemas";
import Breadcrumb from "@/components/base/Breadcrumb";

const experience = [
  {
    period: "10.10.2018 – obecnie",
    company: "Własna działalność gospodarcza",
    role: "Broker finansowy – Ekspert kredytowy",
    description:
      "Samodzielna działalność pod marką EXPERT KREDYTOWY. Kompleksowa analiza kredytowa dla klientów indywidualnych i przedsiębiorców. Analiza ofert wielu banków, przygotowanie dokumentacji, negocjacje warunków oraz pełne wsparcie na każdym etapie procesu kredytowego.",
  },
  {
    period: "01.06.2018 – 2019",
    company: "mFinanse SA",
    role: "Ekspert Kredytowy",
    description:
      "Analiza kredytowa hipoteczna i gotówkowa. Analiza zdolności kredytowej, porównywanie ofert bankowych, przygotowanie wniosków kredytowych oraz obsługa klientów indywidualnych.",
  },
  {
    period: "20.11.2017 – 31.05.2018",
    company: "Podkarpacki Bank Spółdzielczy",
    role: "Starszy Ekspert Kredytowy",
    description:
      "Zaawansowana analiza kredytowa dla klientów indywidualnych i biznesowych. Budowanie długoterminowych relacji z klientami, analiza potrzeb finansowych oraz rekomendacja produktów bankowych.",
  },
  {
    period: "15.06.2016 – 19.11.2017",
    company: "Podkarpacki Bank Spółdzielczy",
    role: "Dyrektor Departamentu Wierzytelności Trudnych",
    description:
      "Nadzór nad procesami windykacji i zarządzania wierzytelnościami trudnymi. Opracowywanie strategii odzyskiwania należności, negocjacje z dłużnikami oraz koordynacja pracy zespołu.",
  },
  {
    period: "01.09.2013 – 14.06.2016",
    company: "Podkarpacki Bank Spółdzielczy",
    role: "Kierownik Sekcji Współpracy z Klientami Biznesowymi",
    description:
      "Kierowanie sekcją obsługi klientów biznesowych. Pozyskiwanie i obsługa firmowych klientów banku, analiza wniosków kredytowych przedsiębiorstw oraz rozwój produktów dla sektora MŚP.",
  },
  {
    period: "01.09.2012 – 31.08.2013",
    company: "Podkarpacki Bank Spółdzielczy",
    role: "Kierownik Sekcji Bankowości Korporacyjnej",
    description:
      "Zarządzanie obsługą klientów korporacyjnych. Analiza dużych wniosków kredytowych, relacje z kluczowymi klientami biznesowymi oraz rozwój portfolio kredytowego.",
  },
  {
    period: "21.01.2009 – 31.08.2012",
    company: "Podkarpacki Bank Spółdzielczy",
    role: "Kierownik Sekcji Kredytów",
    description:
      "Kierowanie sekcją kredytową banku. Nadzór nad procesem obsługi kredytowej, analiza ryzyka kredytowego oraz optymalizacja procedur udzielania kredytów.",
  },
  {
    period: "01.08.2004 – 20.01.2009",
    company: "Podkarpacki Bank Spółdzielczy",
    role: "Kierownik Sekcji Kredytów i Windykacji",
    description:
      "Kompleksowe zarządzanie sekcją kredytów oraz windykacji. Nadzór nad całym cyklem kredytowym – od analizy wniosku po monitoring spłat i obsługę zaległości.",
  },
  {
    period: "01.02.2004 – 31.07.2004",
    company: "Podkarpacki Bank Spółdzielczy",
    role: "Inspektor kredytowy",
    description:
      "Szczegółowa analiza wniosków kredytowych, weryfikacja zdolności kredytowej klientów oraz ocena ryzyka kredytowego przy udzielaniu finansowania.",
  },
  {
    period: "01.04.2000 – 31.01.2004",
    company: "Podkarpacki Bank Spółdzielczy",
    role: "Referent kredytowy",
    description:
      "Obsługa procesów kredytowych – przyjmowanie wniosków, wstępna analiza dokumentacji, kontakt z klientami oraz przygotowanie materiałów do decyzji kredytowych.",
  },
  {
    period: "01.04.1999 – 31.03.2000",
    company: "Podkarpacki Bank Spółdzielczy",
    role: "Referent ds. administracyjno-gospodarczych",
    description:
      "Obsługa spraw administracyjnych i gospodarczych banku. Organizacja pracy biurowej, administracja dokumentacji oraz wsparcie operacyjne działu kredytowego.",
  },
];

const education = [
  {
    school: "Wyższa Szkoła Bankowa w Rzeszowie",
    degree: "Magister Finansów i Rachunkowości",
    period: "1998 – 2003",
  },
];

const certifications = [
  "Certyfikowany Ekspert Kredytowy – Polska Izba Finansowa",
  "Certyfikat KNF w zakresie doradztwa inwestycyjnego",
  "Szkolenie z zaawansowanej analizy finansowej przedsiębiorstw – SGH Warszawa",
  "Certyfikat Bancassurance – ubezpieczenia kredytowe i grupowe",
  "Szkolenia z zarządzania wierzytelnościami trudnymi",
  "Regularne szkolenia z nowoczesnych produktów kredytowych i regulacji rynkowych",
];

const specializations = [
  "Kredyty hipoteczne",
  "Kredyty gotówkowe",
  "Kredyty firmowe",
  "Refinansowanie",
  "Konsolidacja zobowiązań",
  "Analiza finansowa",
  "Ubezpieczenia kredytowe",
  "Leasing",
  "Analiza zdolności kredytowej",
  "Negocjacje z bankami",
];

export default function AboutPage() {

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLD data={personSchema} />
      <Navbar />

      <main>
        {/* Hero */}
        <section className="pt-24 md:pt-32 pb-10 md:pb-14 bg-background-50">
          <div className="mx-auto max-w-[1440px] px-4 text-center md:px-8 lg:px-16 xl:px-20">
            <Breadcrumb />
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-accent-500 mb-3 block">
              O mnie
            </span>
            <h1 className="mx-auto max-w-3xl font-heading text-3xl text-foreground-950 md:text-4xl lg:text-5xl">
              Poznaj swojego doradcę – Jan Wojdyła
            </h1>
          </div>
        </section>

        {/* Content */}
        <section className="pb-16 md:pb-24">
          <div className="mx-auto max-w-[1440px] px-4 md:px-8 lg:px-16 xl:px-20">
            <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-16">
              {/* Photo */}
              <div>
                <div className="w-full h-[400px] md:h-[520px] lg:h-[640px] rounded-2xl overflow-hidden bg-neutral-900">
                  <img
                    src="https://storage.readdy-site.link/project_files/4e257fdf-86c3-45fa-9fad-66a82fd8796b/093aca7f-e4f0-48e1-b20a-e152c70c9620_compressed_janek.webp"
                    alt="Jan Wojdyła – ekspert kredytowy i finansowy"
                    className="w-full h-full object-contain object-top"
                  />
                </div>
                <div className="mt-6 flex items-center gap-3 bg-primary-500/5 rounded-xl px-5 py-4 border border-primary-500/10">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 shrink-0">
                    <i className="ri-calendar-check-line text-white text-lg" />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-800">Od 1999 roku w finansach</p>
                    <p className="text-xs text-foreground-500">Ponad 25 lat doświadczenia bankowego i doradczego</p>
                  </div>
                </div>
              </div>

              {/* CV */}
              <div className="flex flex-col gap-8">
                <div>
                  <h2 className="font-heading text-xl font-semibold text-foreground-950 mb-3">
                    Profil zawodowy
                  </h2>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    Niezależny ekspert kredytowy i finansowy z ponad 25-letnim doświadczeniem w branży bankowej i finansowej. Moja kariera rozpoczęła się w 1999 roku w Podkarpackim Banku Spółdzielczym, gdzie przeszedłem ścieżkę od referenta ds. administracyjnych aż do stanowiska dyrektora departamentu. Przez lata zdobyłem głęboką wiedzę o produktach kredytowych, procesach bankowych, analizie ryzyka oraz zarządzaniu wierzytelnościami. Obecnie, jako właściciel marki EXPERT KREDYTOWY, oferuję kompleksową analizę kredytową opartą na solidnym doświadczeniu z obu strony stołu – zarówno jako pracownik banku, jak i niezależny broker finansowy.
                  </p>
                </div>

                <div>
                  <h2 className="font-heading text-xl font-semibold text-foreground-950 mb-4">
                    Doświadczenie zawodowe
                  </h2>
                  <div className="flex flex-col gap-4">
                    {experience.map((exp, idx) => (
                      <div key={idx} className="flex gap-4">
                        <div className="flex flex-col items-center shrink-0">
                          <div className="w-3 h-3 rounded-full bg-accent-500" />
                          {idx < experience.length - 1 && (
                            <div className="w-0.5 flex-1 bg-background-200 my-1" />
                          )}
                        </div>
                        <div className="pb-2">
                          <p className="text-xs font-medium text-accent-500 mb-0.5">{exp.period}</p>
                          <p className="text-sm font-semibold text-foreground-800">{exp.role}</p>
                          <p className="text-xs text-foreground-500 mb-1">{exp.company}</p>
                          <p className="text-sm text-foreground-600 leading-relaxed">{exp.description}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div>
                  <h2 className="font-heading text-xl font-semibold text-foreground-950 mb-4">
                    Wykształcenie
                  </h2>
                  <div className="flex flex-col gap-3">
                    {education.map((edu, idx) => (
                      <div key={idx} className="flex gap-4">
                        <div className="w-1 bg-accent-500 rounded-full shrink-0" />
                        <div>
                          <p className="text-sm font-semibold text-foreground-800">{edu.school}</p>
                          <p className="text-xs text-foreground-500">{edu.degree} | {edu.period}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div>
                  <h2 className="font-heading text-xl font-semibold text-foreground-950 mb-3">
                    Szkolenia i certyfikaty
                  </h2>
                  <ul className="flex flex-col gap-2">
                    {certifications.map((cert) => (
                      <li key={cert} className="flex items-start gap-2.5">
                        <div className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 shrink-0 mt-0.5">
                          <i className="ri-check-line text-accent-500 text-xs" />
                        </div>
                        <span className="text-sm text-foreground-600">{cert}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div>
                  <h2 className="font-heading text-xl font-semibold text-foreground-950 mb-3">
                    Specjalizacje
                  </h2>
                  <div className="flex flex-wrap gap-2">
                    {specializations.map((spec) => (
                      <span
                        key={spec}
                        className="px-4 py-2 bg-background-100 text-sm font-medium text-foreground-700 rounded-full border border-background-200"
                      >
                        {spec}
                      </span>
                    ))}
                  </div>
                </div>

                <div>
                  <h2 className="font-heading text-xl font-semibold text-foreground-950 mb-3">
                    Obszar działania
                  </h2>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                    Sanok, Brzozów, Lesko, Krosno, Ustrzyki Dolne, Dynów, Zagórz, Bieszczady oraz całe województwo podkarpackie.
                  </p>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    Konsultacje osobiste, telefoniczne i online.
                  </p>
                </div>

                <div>
                  <h2 className="font-heading text-xl font-semibold text-foreground-950 mb-3">
                    Podejście do klienta
                  </h2>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    Każdy klient traktowany jest indywidualnie. Nie stosuję schematów – analizuję konkretną sytuację, potrzeby i cele. Komunikacja jest jasna, transparentna i bez nacisku sprzedażowego. Stawiam na zbudowanie relacji opartej na zaufaniu i rzetelnej wiedzy. Dzięki wieloletniemu doświadczeniu po stronie banku doskonale rozumiem, jak instytucje finansowe oceniają wnioski i jakie dokumenty są kluczowe – to przekłada się na wyższą skuteczność i lepsze warunki dla moich klientów.
                  </p>
                </div>

                <a
                  href="tel:698084044"
                  className="inline-flex px-7 py-3.5 bg-primary-500 text-white font-semibold rounded-full hover:bg-primary-600 transition-colors shadow-md whitespace-nowrap cursor-pointer self-start"
                >
                  Zadzwoń – umów konsultację
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
